import type { Price } from '@noths/polaris-dev-ts-types';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { adaptDeliverySettingsToState } from 'src/adapters/serviceToState/adaptDeliverySettingsToState';
import type { ReduxApplicationState } from 'src/redux/types';
import { fetchDeliveryOptions } from 'src/services/delivery-settings/fetchDeliveryOptions';
import type { DeliveryZone } from './types';

interface RequestDeliveryZoneOptions {
  productCode: number;
  productPrice: Price;
}

export const requestDeliveryZoneOptions = createAsyncThunk<
  DeliveryZone[],
  RequestDeliveryZoneOptions,
  { rejectValue: Error }
>(
  'delivery/requestDeliveryZoneOptions',
  async ({ productCode, productPrice }, { getState, rejectWithValue }) => {
    try {
      const userCurrencyCode = (getState() as ReduxApplicationState).user.currencyCode;
      const deliveryZoneOptions = await fetchDeliveryOptions(productCode, productPrice);

      return adaptDeliverySettingsToState(deliveryZoneOptions, userCurrencyCode);
    } catch (error) {
      const serializableError =
        error instanceof Error
          ? { message: error.message, name: error.name, stack: error.stack }
          : { message: 'Unknown error fetching delivery options', name: 'Error' };

      return rejectWithValue(serializableError);
    }
  },
);
